import { render } from "./sf-inpage-list.vue?vue&type=template&id=518b9caf"
const script = {}

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__